import React from "react";
import { ListItem, ListItemText } from "@material-ui/core";
import { CopyIconButton } from "../../CopyIconButton";

export const TextItem = ({ label, value, copy }) => {
  return (
    <ListItem
      sx={{ py: 0, my: 0 }}
      secondaryAction={copy && <CopyIconButton text={value} edge="end" />}
    >
      <ListItemText
        inset
        primary={label}
        secondary={value}
        secondaryTypographyProps={{
          sx: {
            wordWrap: "break-word",
          },
        }}
      />
    </ListItem>
  );
};
